var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ehc-page',[_c('h1',[_vm._v("My Account")])])
}
var staticRenderFns = []

export { render, staticRenderFns }